var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"portal"},[_c('Header',{attrs:{"heading":"Välkommen till portalen för MMS&nbsp;analysverktyg","subheading":"Denna sida fungerar som en portal\n          för&nbsp;att&nbsp;nå&nbsp;MMS&nbsp;olika&nbsp;webbverktyg."}}),_c('Webservices')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }